module.exports = {
	"AlsoToday": "Lees vandaag ook",
	"Archive": "Archief",
	"ClickHereForMoreInfo": "Klik hier voor meer info",
	"ClientWebServiceNotResponding": "De authenticatie service is momenteel onbeschikbaar",
	"Confirm": "Bevestig",
	"Digital": "Digitale",
	"DigitalVersion": "Digitale",
	"Edition": "Editie",
	"Help": "Hulp nodig?",
	"HorsSeries": "Extra",
	"LoadingNewspaperPleaseWait": "De krant wordt geladen, even geduld aub...",
	"LogIn": "Login",
	"LogInWith": "Of meld aan met:",
	"MaximumDeviceNumberReached": "U heeft met dit abonnement het maximaal aantal toegangen tot deze editie bereikt.",
	"ModernBrowserRequired": "U zoekt de digitale krant? Deze vereist Internet Explorer 9 of hoger. Wij raden u aan uw browser te updaten of via een andere browser te surfen (Chrome, Firefox,...).",
	"More": "Meer",
	"NewspaperCurrentlyUnavailable": "De krant kan momenteel niet geopend worden. Probeer later opnieuw.",
	"NoDigitalAccess": "U heeft momenteel geen digitale toegang",
	"OK": "OK",
	"Paper": "Papieren",
	"PaperVersion": "Papieren",
	"Password": "Wachtwoord",
	"PleaseFillInAllFields": "Gelieve alle velden in te vullen!",
	"Promospot": "Promospot",
	"ReadingPreference": "Leesvoorkeur",
	"ReadTheNewspaper": "Lees de krant",
	"Read": "Lees",
	"SelectEdition": "Selecteer een editie:",
	"SignIn": "Meld aan",
	"SignOut": "Meld af",
	"SSOValidationFailed": "Automatische authenticatie is mislukt.",
	"Subscription": "Abonnement",
	"TemporarilyUnavailable": "Tijdelijk onbeschikbaar",
	"TheUsernameAndOrPasswordIsIncorrect": "Fout wachtwoord en/of e-mailadres/gebruikersnaam",
	"UnknownError": "Er is een onverwachte fout opgetreden",
	"UnknownUser": "Fout e-mailadres/gebruikersnaam",
	"Username": "E-mailadres",
	"ValidationFailed": "De authenticatie service is momenteel onbeschikbaar.",
	"YourSessionHasExpired": "Uw sessie is verlopen",
	"downloadPDFerror": "U hebt de maximale download limiet bereikt voor deze editie. ",
	"ForgotPassword": "Paswoord vergeten",
	"Cancel": "Annuleer",
	"moment": "nl",
	"Extra": "Extra",
	"ChooseRegion": "Kies een regio alstublieft",
	"downloadingNewsPaper": "Uw krant is aan het downloaden, even geduld aub. ",
	"CookieConfirmButton": "OK",
	"CookieLinkText": "Meer informatie",
	"CookieInformText": "Deze website maakt gebruik van cookies. Door verder te surfen, stemt u in met deze cookies. ",
	"home": "Home",
	"recently": "Recent",
	"supplements": "Supplementen",
	"extras": "Extras",
	"inforAndExtras": "Info en extras",
	"regions": "Regio's",
	"settings": "Instellingen",
	"region": "Regio",
	"login": "Log in",
	"logout": "Log uit",
	"help": "Help",
	"about": "Over",
	"disclaimer": "Disclaimer",
	"account": "Account",
	"accountLoggedIn": "Ingelogd",
	"accountLoggedInInfo": "u bent momenteel ingelogd.",
	"accountLoggedWithInfo": "u bent momenteel ingelogd",
	"accountLoggedOut": "Niet ingelogd",
	"version": "Versie",
	"platformversion": "Platform versie",
	"uuid": "UUID",
	"editor": "Editor",
	"developer": "Ontwikkelaar",
	"downloading": "Downloaden...",
	"Proceed": "Volgende",
	"journal": "Krant",
	"alsoRead": "Lees ook",
	"alsoWatch": "Bekijk ook",
	"alsoSee": "Zie ook",
	"authorising": "Authorisatie...",
	"notSupported": "Deze website kan enkel op moderne browsers weergegeven worden. Gelieve uw browser bij te werken of Chrome te downloaden.",
	"printImage": "Afbeelding",
	"printText": "Tekst",
	"print": "Print",
	"jumpBack": "Back",
	"noInternetNoVideo": "U moet verbonden zijn met het internet om deze video te kunnen bekijken.",
	"download": "Download",
	"fullPdfDownload": "Volledige publicatie",
	"pagePdfDownload": "Huidige pagina",
	"pdfDownloadTooltip": "Downloaden",
	"logoTooltip": "Terug naar de kiosk",
	"readerLogoTooltip": "Terug naar de kiosk",
	"landscapeToggle": "Lezen in liggende modus",
	"singlePage": "Weergave van één pagina",
	"singlePageShort": "één pagina",
	"doublePage": "Weergave van twee pagina’s",
	"doublePageShort": "twee pagina’s",
	"passwordForgottenLoadingText": "Gelieve even te wachten terwijl de pagina laadt",
	"landscapeToggleEExplanation": "Wanneer u in liggende modus leest, kan u kiezen om één pagina in de volledige breedte weer te geven of om twee pagina’s naast elkaar weer te geven.",
	"PleaseFillInAValidEmail": "Gelieve een geldig e-mailadres in te vullen.",
	"LeftPage": "Linkerpagina",
	"RightPage": "Rechterpagina",
	"Sorry": "Sorry!",
	"close": "Sluiten",
	"printLeftPage": "Linkerpagina",
	"printRightPage": "Rechterpagina",
	"printSinglePage": "Huidige pagina",
	"cropPrint": "Print",
	"cropPrintInstruction": "Om de volledige pagina te printen, druk \"Print\".<br>Om een deel van de pagina of een specifiek artikel te printen, pas de grootte aan van de blauwe kader door de hoeken te verslepen en ze te plaatsen rond het deel van de pagina dat u zou willen printen.",
	"cropPrintTitle": "Print",
	"openCMPSetting": "Mijn privacy instellingen",
	"dataPolicy": "Persoonlijke gegevens",
	"privacyPolicy": "Cookie beleid",
	"singlePageMode": "Weergave van één pagina",
	"doublePageMode": "Weergave van twee pagina's",
	"readingModeToggle": "Leesmodus",
	"E1": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
	"E2": "",
	"E3": "De authenticatie service is momenteel onbeschikbaar",
	"E4": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
	"E5": "U heeft momenteel geen digitale toegang.",
	"E6": "Fout wachtwoord en/of e-mailadres/gebruikersnaam",
	"E7": "Fout wachtwoord en/of e-mailadres/gebruikersnaam",
	"E8": "De krant kan momenteel niet geopend worden. Probeer later opnieuw.",
	"E9": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
	"E11": "U heeft met dit abonnement het maximaal aantal toegangen tot deze editie bereikt.",
	"E13": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
	"E15": "De systemen zijn niet beschikbaar, gelieve later opnieuw te proberen.",
	"E16": "Er is een onverwachte fout opgetreden",
	"E17": "De authenticatie service is momenteel onbeschikbaar",
	"E20": "De authenticatie service is momenteel onbeschikbaar",
	"E21": "De authenticatie service is momenteel onbeschikbaar",
	"E24": "Uw abonnement heeft niet voldoende rechten om de publicatie te lezen.",
	"E25": "Maximum aantal gelijktijdige gebruikers bereikt voor dit abonnement. Probeer later opnieuw.",
	"E26": "Deze inloggegevens kunnen niet worden geverifieerd. Probeer het opnieuw of neem contact op met onze klantenservice."
};


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/nl_BE.json
// module id = 412
// module chunks = 0 1